import * as React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { Modal } from 'react-inv-forms';
import { Paragraph } from './SigninAsTeacherModal.style';
import authAsActions from '../../../redux/authAs/actions';
import { SignAsTeacherPayload } from '../../../redux/authAs/types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { RootState } from '../../../redux/reducers';
import { Select } from 'antd';
import { debounce } from 'debounce';

const { Option } = Select;
const { closeSigninAsTeacherModal, getTeachers, signinAsTeacher, setSelectedTeacher } = authAsActions;

type MapStateToProps = ReturnType<typeof mapStateToProps>;
type MapDispatchToProps = ReturnType<typeof mapDispatchToProps>;

type Props = MapStateToProps & MapDispatchToProps & WithTranslation;

/**
 *  Komponent modala wyboru nauczyciela, na którego supernauczyciel chce się zalogować
 *
 */
export class SigninAsTeacherModal extends React.Component<Props> {
  onSearch = (value: string): void => {
    const trimmed = value.trim();
    if (trimmed !== '' && trimmed.length > 2) this.props.getTeachers(value);
  };
  onChange = (value: number): void => {
    this.props.setSelectedTeacher({ id: value });
  };
  render(): React.ReactElement {
    const { teacherModal, closeSigninAsTeacherModal, signinAsLoader, signinAsTeacher } = this.props;
    const { opened, loading, selectedValue, teachers } = teacherModal;
    const selectedTeacher = teachers.find((teacher: AppConfig.Teacher) => teacher.prowadzacyPId === selectedValue);
    return (
      <Modal
        visible={opened}
        okText={this.props.t('SUPERTEACHER_MODAL_CONFIRM')}
        cancelText={this.props.t('CANCEL')}
        okButtonProps={{ disabled: !selectedValue }}
        onCancel={closeSigninAsTeacherModal}
        confirmLoading={signinAsLoader}
        onOk={signinAsTeacher}
        title={this.props.t('SUPERTEACHER_MODAL_LOGIN_AS')}
        destroyOnClose
        className='cySigninAsTeacherModal'
      >
        <h3>{this.props.t('SUPERTEACHER_MODAL_SELECT_A_TEACHER')}:</h3>
        <Select
          loading={loading}
          showSearch
          placeholder={this.props.t('START_TYPING')}
          onChange={this.onChange}
          notFoundContent={this.props.t('NO_DATA')}
          filterOption={() => true}
          onSearch={debounce(this.onSearch, 200)}
          dropdownClassName='custom_dropdown'
          className='custom_select'
          value={selectedValue ? selectedValue : undefined}
          autoFocus
          data-cy='selectChooseTeacher'
        >
          {teachers.map((teacher: AppConfig.Teacher) => (
            <Option key={teacher.prowadzacyPId} value={teacher.prowadzacyPId} className='custom_option'>
              {`
              ${teacher.prowadzacyImie}
              ${teacher.prowadzacyNazwisko}
              (${teacher.prowadzacyJednostka.map((unit, idx: number) => `${idx === 0 ? '' : ' '}${unit}`)})`}
            </Option>
          ))}
        </Select>
        {selectedTeacher ? (
          <Paragraph>
            {this.props.t('SUPERTEACHER_MODAL_SUBSTITUTE')}
            :&nbsp;
            <strong>{`${selectedTeacher.prowadzacyImie} ${selectedTeacher.prowadzacyNazwisko}`}</strong>
          </Paragraph>
        ) : (
          ''
        )}
      </Modal>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  teacherModal: state.AuthAs.teacherModal,
  signinAsLoader: state.AuthAs.loading,
});

const mapDispatchToProps = (dispatch: any) => ({
  closeSigninAsTeacherModal: () => dispatch(closeSigninAsTeacherModal()),
  getTeachers: (value: string) => dispatch(getTeachers(value)),
  setSelectedTeacher: (payload: SignAsTeacherPayload) => dispatch(setSelectedTeacher(payload)),
  signinAsTeacher: () => dispatch(signinAsTeacher()),
});

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps),
)(SigninAsTeacherModal) as React.ComponentType<any>;
